import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a position in a string marks the start of a UTF-16 surrogate pair.
*
* @module @stdlib/assert/has-utf16-surrogate-pair-at
*
* @example
* var hasUTF16SurrogatePairAt = require( '@stdlib/assert/has-utf16-surrogate-pair-at' );
*
* var bool = hasUTF16SurrogatePairAt( '🌷', 0 );
* // returns true
*
* bool = hasUTF16SurrogatePairAt( '🌷', 1 );
* // returns false
*/

// MODULES //
var hasUTF16SurrogatePairAt = __var_0__;


// EXPORTS //
export default hasUTF16SurrogatePairAt;
